import { navItems } from "@/mocks/siteContent";

export default function Footer() {
  const go = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-home-heart-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">邻居的妻子 · 题材站</span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed">
              围绕同一题材母题，整理短剧、小说、电影各版本的剧情走向、看点差异与未删减方向，帮助你更快找到对味的作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">页面导航</h4>
            <ul className="grid grid-cols-2 gap-y-2.5 gap-x-4">
              {navItems.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => go(item.id)}
                    className="text-sm text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">内容说明</h4>
            <ul className="space-y-2.5 text-sm text-background-200/80 leading-relaxed">
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 shrink-0 text-accent-300" aria-hidden="true"></i>
                <span>本站为题材整理，不指向特定作品，具体信息以官方片源与出版物为准。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 shrink-0 text-accent-300" aria-hidden="true"></i>
                <span>所有推荐与说明均为页面内静态内容，不涉及真实提交或账号系统。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/12 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">© 2026 邻居的妻子 · 题材站 · 内容仅供影视娱乐参考</p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-2 text-xs text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}